import { IJCState, IJCStateFromApi } from '~/types/models/jcState';
import { IJCStatus, IJCStatusFromApi } from '~/types/models/jcStatus';
import { Dictionary } from '~/types/general';
import axiosBase from '~/utils/axios';
import { CompanyResponseT } from '~/types/response/companies';
import { IServicePersonsT } from '~/types/response/servicePersons';
import { IDepartmentResponse } from '~/types/response/department';
import { ISubDepartmentResponse } from '~/types/response/subDepartment';
import { IWorkstationResponse } from '~/types/response/workstation';

const dictPrefixUrl = '/tenantDicts';

const apiDictsPrefixUrl = '/apiDicts';

export default class DictionaryApi {
  public static async getJcStates(id: string, params: any): Promise<{ JCStates: IJCState[] }> {
    return axiosBase
      .get(`${dictPrefixUrl}/${id}`, {
        params,
      })
      .then(({ data }) => data);
  }

  public static async getJcStatuses(id: string, params: any): Promise<{ JCStatuses: IJCStatus[] }> {
    return axiosBase
      .get(`${dictPrefixUrl}/${id}`, {
        params,
      })
      .then(({ data }) => data);
  }

  public static async getBranches(id: string, params: any): Promise<{ Branches: Dictionary[] }> {
    return axiosBase
      .get(`${dictPrefixUrl}/${id}`, {
        params,
      })
      .then(({ data }) => data);
  }

  public static getCompanies(): Promise<CompanyResponseT[]> {
    return axiosBase.get('/companies').then(({ data }) => data);
  }

  public static getServicePerson(employeId: string, companyId: string): Promise<IServicePersonsT> {
    return axiosBase.post(`/servicepersons/${employeId}`, { companyId }).then(({ data }) => data);
  }

  public static async getJcStatesFromApi(): Promise<IJCStateFromApi[]> {
    return axiosBase.get(`${apiDictsPrefixUrl}/jobCardStates`).then(({ data }) => data);
  }

  public static async getJcStatusesFromApi(): Promise<IJCStatusFromApi[]> {
    return axiosBase.get(`${apiDictsPrefixUrl}/jobCardStatuses`).then(({ data }) => data);
  }

  public static async getDepartmentsFromApi(): Promise<IDepartmentResponse[]> {
    return axiosBase.get(`${apiDictsPrefixUrl}/departments`).then(({ data }) => data);
  }

  public static async getSubDepartmentsFromApi(): Promise<ISubDepartmentResponse[]> {
    return axiosBase.get(`${apiDictsPrefixUrl}/subDepartments`).then(({ data }) => data);
  }

  public static async getWorkstationsFromApi(): Promise<IWorkstationResponse[]> {
    return axiosBase.get(`${apiDictsPrefixUrl}/workstations`).then(({ data }) => data);
  }
}
